(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // `snippets/cart-quantity.liquid` draws the stepper for both the cart page and
  // this drawer, but a snippet's `javascript` tag never reaches the storefront —
  // only its `stylesheet` tag is compiled. This section is where the element is
  // defined instead, because it is the one section rendered on every page (from
  // `layout/theme.liquid`), so the cart page gets it too.
  //
  // The comps draw the stepper but not what it does. Clamping at the field's own
  // `min` keeps the two ways in agreeing — the buttons and a typed number — and
  // dispatching `change` on the field means each host has one code path for both.
  //
  // Nothing here writes to the cart: the host owns `/cart/change.js` and the
  // re-render that follows it, which is what puts the authoritative quantity, the
  // stock ceiling and the disabled states back on screen.
  class CartQuantity extends HTMLElement {
    connectedCallback() {
      this.field = this.querySelector('.cart-quantity__input');

      // The quantity the server rendered. A change that lands back on it — a 0
      // typed in and clamped to 1, say — has nothing to write.
      this.rendered = Number(this.field?.value);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('keydown', this.onKeydown);
    }

    get floor() {
      return Number(this.field.min) || 1;
    }

    onClick = (event) => {
      const step = event.target.closest('[data-cart-step]');
      if (!step || !this.field) return;

      this.field.value = this.clamp(Number(this.field.value) + Number(step.dataset.cartStep));

      // Going back out through a real event rather than calling the host
      // directly: the host listens to the field, so a button press and a typed
      // number arrive the same way.
      this.field.dispatchEvent(new Event('change', { bubbles: true }));
    };

    // On the cart page the field sits in the form that posts to `/cart`, and the
    // first submit button in that form is 「レジに進む」 — so confirming a typed
    // quantity with Enter would leave for checkout. It confirms the quantity
    // instead, which is what 05_cart B-2 says the field does.
    onKeydown = (event) => {
      if (event.key !== 'Enter' || event.target !== this.field) return;

      event.preventDefault();
      this.field.dispatchEvent(new Event('change', { bubbles: true }));
    };

    onChange = (event) => {
      if (event.target !== this.field) return;

      this.field.value = this.clamp(Number(this.field.value));

      // 0 and an empty field both clamp to 1, which is the quantity the line
      // already holds — so there is nothing for the host to write and the event
      // stops here (05_cart B-3).
      if (Number(this.field.value) === this.rendered) event.stopPropagation();
    };

    clamp(quantity) {
      return String(Math.max(this.floor, Math.floor(quantity) || this.floor));
    }
  }

  if (!customElements.get('cart-quantity')) {
    customElements.define('cart-quantity', CartQuantity);
  }

  // The cart drawer owns every write to the cart: the product form posts through
  // it, and so do the drawer's own steppers and remove buttons. After each write
  // it re-renders itself rather than patching the DOM, so the money formatting
  // and the tax suffix stay server-side.
  //
  // The markup comes back with the write: `/cart/add.js` and `/cart/change.js`
  // take a `sections` parameter and return those sections rendered against the
  // updated cart. That makes a write one round trip instead of the write and a
  // separate `?section_id=` fetch after it.
  class CartDrawer extends HTMLElement {
    static SECTION = 'cart-drawer';
    connectedCallback() {
      this.dialog = this.querySelector('dialog');

      // Delegated on the document, not on the element: the drawer opens from the
      // header and from the product form, both of which are outside it, and the
      // element itself is replaced on every refresh.
      if (!CartDrawer.bound) {
        CartDrawer.bound = true;
        document.addEventListener('submit', CartDrawer.onSubmit);
        document.addEventListener('click', CartDrawer.onClick);
        document.addEventListener('change', CartDrawer.onChange);
      }
    }

    static get current() {
      return document.querySelector('cart-drawer');
    }

    // What a write asks to have rendered. On `/cart` the page's own table is
    // showing the same lines, so its section rides along on the same request.
    static get sections() {
      const page = document.querySelector('cart-page');
      return page ? [CartDrawer.SECTION, page.dataset.sectionId] : [CartDrawer.SECTION];
    }

    // The two parameters every write carries. `sections_url` is the page the
    // sections are rendered against: the drawer is on every page, and the cart
    // page's section only exists on `/cart`.
    static get sectionParams() {
      return { sections: CartDrawer.sections.join(','), sections_url: window.location.pathname };
    }

    static onSubmit(event) {
      const form = event.target.closest('form[action$="/cart/add"]');
      if (!form) return;

      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      const body = new FormData(form);
      for (const [name, value] of Object.entries(CartDrawer.sectionParams)) body.append(name, value);

      // `form 'product'` posts to `/cart/add`; the `.js` endpoint is the one
      // documented to take `sections`. The action keeps any locale prefix.
      const endpoint = new URL(form.action, window.location.href);
      endpoint.pathname += '.js';

      fetch(endpoint, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      })
        .then((response) => {
          if (!response.ok) return undefined;
          // `snippets/analytics-loader.liquid` waits for the first add before it
          // writes its cart attribute, so an empty cart is never created just to
          // hold it.
          document.dispatchEvent(new CustomEvent('bsharp:cart-added'));
          return response.json();
        })
        .then((result) => CartDrawer.update(result?.sections))
        .then(() => CartDrawer.current?.open())
        .finally(() => {
          if (button) button.disabled = false;
        });
    }

    static onClick(event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        CartDrawer.current?.close();
        return;
      }

      // Opens first and refreshes behind it. Every write on this page already
      // re-renders the drawer, so what opens is normally current; the refresh
      // catches what the page cannot see — a write from another tab, or a page
      // restored from the back-forward cache. Writes wait for it (see `change`),
      // since a line number on stale markup can point at a different line.
      if (event.target.closest('[data-cart-drawer-open]')) {
        event.preventDefault();
        const drawer = CartDrawer.current;
        if (!drawer) return;

        drawer.open();
        drawer.dataset.refreshing = 'true';
        CartDrawer.refresh().catch(() => {
          delete drawer.dataset.refreshing;
        });
        return;
      }

      // On `/cart` the page's own line items carry the same hooks and handle
      // themselves, so only what happened inside the drawer is the drawer's.
      const drawer = event.target.closest('cart-drawer');
      if (!drawer) return;

      const remove = event.target.closest('[data-cart-remove]');
      if (remove) drawer.change(Number(remove.dataset.cartRemove), 0);
    }

    // `cart-quantity` writes the field and lets its `change` bubble up here, so
    // the stepper and a typed number arrive the same way and the floor of 1
    // (05_cart B-3) stays stated once, in the control.
    static onChange(event) {
      const field = event.target.closest('.cart-quantity__input');
      const drawer = field?.closest('cart-drawer');
      if (!drawer) return;

      drawer.change(Number(field.dataset.cartLine), Number(field.value));
    }

    // Renders from the sections a write returned. A write that came back
    // without them — a 422 for a sold-out variant, say — falls back to fetching
    // the drawer, so it still shows what the cart actually holds. The cart page
    // re-renders itself through its own method, which is the one that announces
    // the new total (05_cart B-7).
    static update(sections) {
      const page = document.querySelector('cart-page');
      const html = sections?.[CartDrawer.SECTION];
      if (!html) {
        return CartDrawer.refresh().then(() => page?.refresh?.());
      }

      CartDrawer.render(html);
      const pageHtml = page && sections[page.dataset.sectionId];
      if (pageHtml) page.render?.(pageHtml);
      return Promise.resolve();
    }

    static refresh() {
      return fetch(`${window.Shopify.routes.root}?section_id=${CartDrawer.SECTION}`)
        .then((response) => response.text())
        .then((html) => CartDrawer.render(html));
    }

    // Swap the drawer's markup in place. `dialog` loses its open state when the
    // element is replaced, so an open drawer is re-opened.
    static render(html) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
      const live = CartDrawer.current;
      if (!fresh || !live) {
        // Nothing was swapped, so whatever asked for the render has to be able
        // to try again.
        if (live) {
          delete live.dataset.busy;
          delete live.dataset.refreshing;
        }
        return;
      }

      const wasOpen = live.dialog?.open;
      live.replaceWith(fresh);
      CartDrawer.updateHeaderCount(fresh.dataset.cartCount);
      if (wasOpen) fresh.open();
    }

    // One write at a time, and the busy flag rides on the element the dimming and
    // the spinner are keyed to (05_cart B-6). A render replaces this element, so
    // the flag only has to be cleared when the write fails.
    change(line, quantity) {
      if (this.dataset.busy || this.dataset.refreshing) return;
      this.dataset.busy = 'true';

      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, ...CartDrawer.sectionParams }),
      })
        .then((response) => (response.ok ? response.json() : undefined))
        .then((cart) => CartDrawer.update(cart?.sections))
        .catch(() => {
          // The write failed, so what is on screen is still the truth about the
          // cart. Leaving it interactive lets the customer try again.
          delete this.dataset.busy;
        });
    }

    // The count rides along on the re-rendered drawer rather than costing a
    // second round trip to `/cart.js`, which also removes the race where the
    // badge was still showing the old number after the drawer had opened.
    static updateHeaderCount(count) {
      const badge = document.querySelector('.header__action-count');
      if (!badge) return;
      badge.textContent = count;
      badge.hidden = Number(count) === 0;
    }

    open() {
      this.dialog?.showModal();
    }

    close() {
      this.dialog?.close();
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // The cart page owns every write it makes: the quantity fields and the remove
  // links post to `/cart/change.js`, and the section re-renders itself from the
  // HTML that write returns rather than patching the DOM, so the money
  // formatting, the tax suffix and the stock ceiling all stay server-side. What a quantity is
  // allowed to be belongs to `snippets/cart-quantity.liquid`, which the drawer
  // renders too.
  //
  // Everything degrades without JavaScript: the quantity fields are named
  // `updates[]` inside a form that posts to `/cart`, and the remove links are
  // ordinary `url_to_remove` hrefs.
  class CartPage extends HTMLElement {
    connectedCallback() {
      // Listeners live on the element, not on the document: a refresh replaces
      // the element and the fresh one binds itself.
      this.addEventListener('click', this);
      this.addEventListener('change', this);
    }

    handleEvent(event) {
      if (event.type === 'click') this.onClick(event);
      if (event.type === 'change') this.onChange(event);
    }

    onClick(event) {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;

      event.preventDefault();
      this.change(remove.dataset.cartLine, 0);
    }

    // Both ways of changing a quantity arrive here as a `change` on the field:
    // `cart-quantity` writes the field when a stepper is pressed and lets the
    // event bubble, so the floor of 1 (05_cart B-3) is stated once, in the
    // control, and zero never reaches this method. Removing a line is the
    // 「削除」 link's job.
    onChange(event) {
      const field = event.target.closest('.cart-quantity__input');
      if (!field) return;

      this.change(field.dataset.cartLine, Number(field.value));
    }

    change(line, quantity) {
      if (this.dataset.busy) return;
      this.dataset.busy = 'true';

      const sectionId = this.dataset.sectionId;

      // The drawer rides along: it is on this page too, and without it the
      // drawer would open on the lines as they were before this write.
      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(line),
          quantity,
          sections: [sectionId, 'cart-drawer'].join(','),
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => (response.ok ? response.json() : undefined))
        .then((cart) => {
          const html = cart?.sections?.[sectionId];
          // A write that came back without the markup — a 422, say — still
          // re-renders from the cart as it is.
          if (!html) return this.refresh();

          const drawerHtml = cart.sections['cart-drawer'];
          if (drawerHtml) customElements.get('cart-drawer')?.render?.(drawerHtml);
          this.render(html);
        })
        .catch(() => {
          // The write failed, so the markup on screen is still the truth about
          // the cart. Reloading would hide that; leaving it interactive lets the
          // customer try again.
          delete this.dataset.busy;
        });
    }

    // The fallback when a write did not return the markup.
    //
    // The request goes to `/cart`, not to `/`: a section that lives in
    // `templates/cart.json` only exists on that template, and asking the index
    // for it returns nothing.
    refresh() {
      return fetch(`${window.Shopify.routes.root}cart?section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((html) => this.render(html));
    }

    // Swap this element for a freshly rendered one. `replaceWith` disconnects
    // this instance, so nothing here runs after it.
    render(html) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-page');
      if (!fresh) {
        delete this.dataset.busy;
        return;
      }

      this.replaceWith(fresh);
      CartPage.updateHeaderCount(fresh.dataset.cartCount);
      CartPage.announce(fresh.dataset.totalAnnouncement);
    }

    // Changing a quantity rewrites the total silently: nothing moves focus and
    // the amount is nowhere near the button that was pressed, so a screen
    // reader user gets no confirmation that anything happened.
    //
    // The region lives on `document.body`, not inside the section — `refresh`
    // replaces this element wholesale, and a live region that is inserted at
    // the same moment as its text is not reliably announced. Creating it once
    // and writing into it afterwards is what assistive technology watches for.
    static announce(message) {
      if (!message) return;

      let region = document.getElementById('CartLiveRegion');
      if (!region) {
        region = document.createElement('p');
        region.id = 'CartLiveRegion';
        region.className = 'visually-hidden';
        region.setAttribute('aria-live', 'polite');
        region.setAttribute('role', 'status');
        document.body.appendChild(region);
      }

      region.textContent = message;
    }

    // The count rides along on the re-rendered section rather than costing a
    // second round trip to `/cart.js`.
    static updateHeaderCount(count) {
      const badge = document.querySelector('.header__action-count');
      if (!badge) return;
      badge.textContent = count;
      badge.hidden = Number(count) === 0;
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Upgrades the sort control in `snippets/collection-toolbar.liquid` from
  // "pick, then press 適用" to "pick and go". Lives here because a snippet's
  // javascript block is not delivered — see the note at the foot of that file.
  class SortSelect extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select');
      if (!select || !select.form) return;

      // `requestSubmit` runs validation and fires `submit`; `submit` is the
      // fallback for browsers that upgrade custom elements but lack it.
      select.addEventListener('change', () => {
        if (typeof select.form.requestSubmit === 'function') {
          select.form.requestSubmit();
        } else {
          select.form.submit();
        }
      });
    }
  }

  if (!customElements.get('sort-select')) {
    customElements.define('sort-select', SortSelect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-content"]) return;
  try {
    
  // Takes the browser's own validation UI off the contact form and answers in the
  // page's type instead. `novalidate` is set from here rather than in the markup,
  // so a browser that never runs this still gets the native validation the
  // `required` attributes describe.
  //
  // Every message is authored in Liquid and carried on the control itself
  // (`data-error-empty` / `data-error-format`), because this block is a static
  // bundle that Liquid never renders — the strings have to arrive as data.
  class ContactFormValidation extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.controls = Array.from(this.form.querySelectorAll('[data-error-empty]'));
      this.submitted = false;

      this.form.setAttribute('novalidate', '');
      this.form.addEventListener('submit', this.onSubmit);
      this.controls.forEach((control) => {
        control.addEventListener('input', this.onInput);
        control.addEventListener('change', this.onInput);
      });
    }

    onSubmit = (event) => {
      this.submitted = true;

      const invalid = this.controls.filter((control) => !this.check(control));
      if (invalid.length === 0) return;

      event.preventDefault();
      invalid[0].focus();
    };

    // Re-checking while someone types only helps once they have been told
    // something is wrong; before that it interrupts them mid-word.
    onInput = (event) => {
      if (!this.submitted) return;
      this.check(event.target);
    };

    check(control) {
      const message = this.messageFor(control);
      const output = document.getElementById(control.getAttribute('aria-describedby'));

      if (output) {
        output.textContent = message;
        output.hidden = message === '';
      }

      if (message === '') {
        control.removeAttribute('aria-invalid');
        return true;
      }

      control.setAttribute('aria-invalid', 'true');
      return false;
    }

    messageFor(control) {
      // `valueMissing` does not fire on a field holding only spaces, and a message
      // made of spaces is not a message.
      const filled = String(control.value || '').trim() !== '';
      if (control.validity.valueMissing || !filled) return control.dataset.errorEmpty;
      if (control.validity.typeMismatch) return control.dataset.errorFormat;
      return '';
    }
  }

  if (!customElements.get('contact-form-validation')) {
    customElements.define('contact-form-validation', ContactFormValidation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  // The nav behaviour is Recommend's, class for class and attribute for
  // attribute (`sections/product-carousel.liquid`). What is new here is the
  // auto-advance 01_top A-5 asked for.
  //
  // That request reads as a marquee — "scrolling sideways, always moving" — and a
  // marquee cannot have the dots the same round of answers adds (00_common D-5),
  // because a row moving at constant speed has no current position to mark. The
  // shipped reading is one snap position every few seconds, wrapping to the
  // start, which keeps the row moving on its own *and* keeps a position for the
  // dots and arrows to agree with.
  class GalleryCarousel extends HTMLElement {
    // Long enough to read a card, and the point at which WCAG 2.2.2 starts
    // asking for a way to pause. Three things answer it: `paused` (hover and
    // focus), `stopAutoplay` (a reader driving the row), and the pause button in
    // the nav — the only one a touch reader has, which is why it is drawn.
    static INTERVAL = 5000;

    connectedCallback() {
      this.track = this.querySelector('.gallery__track');
      this.items = Array.from(this.querySelectorAll('.gallery__item'));
      const nav = this.parentElement.querySelector('.carousel-nav');
      if (!this.track || !nav || this.items.length === 0) return;

      this.nav = nav;
      this.dots = Array.from(nav.querySelectorAll('.carousel-nav__dot'));
      this.prev = nav.querySelector('.carousel-nav__button--prev');
      this.next = nav.querySelector('.carousel-nav__button--next');
      this.pauseButton = nav.querySelector('.carousel-nav__pause');

      // The one control that can also *start* the row again. Everything else
      // below ends the auto-advance for good, because those are a reader driving
      // the row; this is a reader asking for the row to move.
      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', () => {
          if (this.timer) this.stopAutoplay();
          else this.startAutoplay();
        });
      }

      this.prev.addEventListener('click', () => {
        this.stopAutoplay();
        this.step(-1);
      });
      this.next.addEventListener('click', () => {
        this.stopAutoplay();
        this.step(1);
      });
      this.dots.forEach((dot, i) =>
        dot.addEventListener('click', () => {
          this.stopAutoplay();
          this.scrollToIndex(i);
        })
      );

      // Once a reader has driven the row themselves, the position is theirs.
      // Resuming would take the card they are reading out from under them, so
      // these end the auto-advance rather than pausing it. `scroll` is not in
      // the list: the auto-advance fires that too, and would stop itself on its
      // first tick.
      ['pointerdown', 'keydown'].forEach((type) =>
        this.addEventListener(type, () => this.stopAutoplay(), { passive: true })
      );

      // A wheel counts only when it is pushing this row sideways. Scrolling the
      // page vertically with the pointer over the carousel fires `wheel` here
      // too, and treating that as taking over would end the auto-advance for
      // someone who only passed through.
      this.addEventListener(
        'wheel',
        (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) this.stopAutoplay();
        },
        { passive: true }
      );

      this.ticking = false;
      this.addEventListener('scroll', () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.sync();
        });
      }, { passive: true });

      // The row can stop overflowing when the viewport grows, so the check has
      // to run again on resize and not only once at connect.
      new ResizeObserver(() => this.sync()).observe(this);

      // Nothing should move while the row is off screen: a reader arriving at
      // the section would find it already at the last card.
      this.onScreen = false;
      new IntersectionObserver((entries) => {
        this.onScreen = entries[0].isIntersecting;
      }).observe(this);

      this.sync();
      this.startAutoplay();
    }

    // 00_common D-6: how many cards can actually lead the row. A card past the
    // last of them is on screen at the final scroll position but can never reach
    // the left edge, so it gets no dot and no arrow stop. How many that is
    // depends on how many cards fit, which is why it is measured here rather than
    // counted in Liquid.
    //
    // It answers the other question too: fewer than two positions means the row
    // already fits and the nav has nothing to do. One measurement, so the dots,
    // the arrows and the nav itself can never disagree about where the row can go.
    get positionCount() {
      const maxScroll = this.scrollWidth - this.clientWidth;
      const base = this.items[0].offsetLeft;
      let count = 0;
      this.items.forEach((item) => {
        if (item.offsetLeft - base <= maxScroll + 1) count += 1;
      });
      return count;
    }

    get index() {
      const left = this.scrollLeft;
      let best = 0;
      let bestDistance = Infinity;
      this.items.forEach((item, i) => {
        const distance = Math.abs(item.offsetLeft - this.items[0].offsetLeft - left);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    }

    // Read at each tick rather than tracked with mouseenter/focusin pairs: two
    // boxes to hover (the row and the nav below it) and a pointer moving from
    // one to the other would leave a flag saying the wrong thing. A pointer
    // resting on a card is not a decision to take over, so this pauses and
    // resumes — unlike the gestures above, which stop for good.
    get paused() {
      return (
        this.matches(':hover') ||
        this.nav.matches(':hover') ||
        this.contains(document.activeElement) ||
        this.nav.contains(document.activeElement)
      );
    }

    startAutoplay() {
      this.timer = setInterval(() => this.advance(), GalleryCarousel.INTERVAL);
      this.syncPauseButton();
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.syncPauseButton();
    }

    // The button and the timer are the same fact, so the control is read off the
    // timer rather than tracked beside it. Whatever ended the auto-advance — this
    // button, an arrow, a swipe — the control is left saying what pressing it
    // will do next, and `aria-pressed` carries the state to a reader who cannot
    // see the glyph. The stylesheet swaps the glyph off the same attribute.
    syncPauseButton() {
      if (!this.pauseButton) return;
      const stopped = !this.timer;
      this.pauseButton.setAttribute('aria-pressed', String(stopped));
      this.pauseButton.setAttribute(
        'aria-label',
        stopped ? this.pauseButton.dataset.resumeLabel : this.pauseButton.dataset.pauseLabel
      );
    }

    advance() {
      // `nav.hidden` means the whole row already fits, so there is nowhere to go.
      if (this.paused || !this.onScreen || this.nav.hidden) return;
      const last = this.positionCount - 1;
      const current = Math.min(this.index, last);
      this.scrollToIndex(current >= last ? 0 : current + 1);
    }

    step(direction) {
      this.scrollToIndex(Math.min(this.index, this.positionCount - 1) + direction);
    }

    scrollToIndex(index) {
      // Clamped to the positions the row can reach, not to the number of cards,
      // so an arrow can never ask for a scroll the row will not make.
      const highest = Math.min(this.positionCount, this.items.length) - 1;
      const target = this.items[Math.min(Math.max(index, 0), highest)];
      if (!target) return;
      this.scrollTo({
        left: target.offsetLeft - this.items[0].offsetLeft,
        behavior: 'smooth'
      });
    }

    sync() {
      const count = this.positionCount;
      this.nav.hidden = count < 2;
      // Whatever the measurement says, the script has now run, so the nav is no
      // longer idle. Taken off even when the nav is hidden, so the state cannot
      // be left describing something that is no longer true.
      this.nav.classList.remove('carousel-nav--idle');
      if (this.nav.hidden) return;

      // Scrolled to the end, `scrollLeft` can sit a pixel or two past the last
      // snap position, which reads as the card after it — a card with no dot.
      // Clamping keeps the fill on the last dot instead of on none of them.
      const current = Math.min(this.index, count - 1);
      this.dots.forEach((dot, i) => {
        // The `<li>` carries the attribute, not the button: the list item is
        // what the dot row lays out.
        dot.parentElement.hidden = i >= count;
        dot.classList.toggle('is-active', i === current);
        // The fill is the only thing that says which dot is current, and colour
        // alone does not carry to assistive technology (WCAG 1.4.1).
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      // By position rather than by `scrollLeft`: the trailing inset means the
      // scroll offset never quite reaches its own maximum, so a comparison
      // against it would leave the next arrow enabled while the last dot is
      // already filled — the same dead control D-6 is about.
      this.prev.disabled = current === 0;
      this.next.disabled = current === count - 1;
    }

    disconnectedCallback() {
      // The theme editor takes sections out and puts them back. A timer left
      // running would keep scrolling an element that is no longer on the page.
      this.stopAutoplay();
    }
  }

  if (!customElements.get('gallery-carousel')) {
    customElements.define('gallery-carousel', GalleryCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Whether the page has moved at all decides the background on TOP (01_top
   * A-1). The attribute is toggled rather than a class so it reads as state,
   * matching `.cart-page[data-busy]`.
   *
   * The free shipping bar sits above the header and scrolls away, so for its
   * first 34px of travel the header is not yet stuck at the top. Anything
   * placed against the viewport under the header (the account sheet) needs
   * that offset, and `--header-offset` carries it. */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      this.toggleAttribute('data-scrolled', window.scrollY > 0);
      this.style.setProperty('--header-offset', `${Math.max(0, this.getBoundingClientRect().top)}px`);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* Every panel in the header is a `details`, so opening and closing works with
   * this script absent — a click, Enter and Space all do it, and the scroll lock
   * in `critical.css` keys off `details[scroll-lock][open]`. What a `details`
   * cannot do by itself is know about its siblings, which is the whole of what
   * this element adds:
   *
   *   - exclusivity. Opening the search while the catalogue is open would stack
   *     two panels; below 1024px the drawer occupies the same space as both.
   *   - Escape. `details` does not close on it, and once the drawer covers the
   *     screen its close button is otherwise the only way out.
   *   - outside click. The comps dim everything under the drop-down panels, so
   *     clicking there has to mean "close".
   *
   * `inert` is the drawer's alone. The full-screen menu leaves everything behind
   * it under 95% white, so tabbing into those links sends the focus ring
   * somewhere the visitor cannot follow. The drop-down panels dim their
   * background to 40% instead — it stays legible, and marking it inert would
   * stop it receiving the very click that closes the panel.
   *
   * `toggle` does not bubble, hence the capture phase. Listeners are added and
   * removed with the element, so the theme editor swapping the section's markup
   * cannot leave a stale node behind. */
  class HeaderPanels extends HTMLElement {
    connectedCallback() {
      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.addEventListener('toggle', this.onToggle, true);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocumentClick);
      this.setInert(false);
    }

    get panels() {
      return this.querySelectorAll('details[scroll-lock]');
    }

    get openPanel() {
      return this.querySelector('details[scroll-lock][open]');
    }

    closeAll(except) {
      this.panels.forEach((panel) => {
        if (panel !== except) panel.open = false;
      });
    }

    setInert(on) {
      for (const el of document.body.children) {
        if (el.contains(this)) continue;
        el.toggleAttribute('inert', on);
      }
    }

    onToggle(event) {
      const panel = event.target;
      if (!panel.matches?.('details[scroll-lock]')) return;

      if (panel.open) this.closeAll(panel);

      if (panel.classList.contains('header__drawer')) this.setInert(panel.open);

      // The search panel is the one place the visitor's next act is typing.
      // Every other panel is a list, and moving focus into it would skip past
      // the label that says what the list is.
      if (panel.open) panel.querySelector('input[type="search"]')?.focus();
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;

      const open = this.openPanel;
      if (!open) return;

      open.open = false;
      open.querySelector('summary')?.focus();
    }

    onDocumentClick(event) {
      const open = this.openPanel;
      if (!open) return;

      // The dim is inside the panel in DOM terms, so it has to be checked before
      // the containment test that keeps clicks on the panel itself from closing.
      const onScrim = event.target.closest?.('[data-header-scrim]');
      if (!onScrim && open.contains(event.target)) return;

      open.open = false;
    }
  }

  if (!customElements.get('header-panels')) {
    customElements.define('header-panels', HeaderPanels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-fv"] && !Shopify.designMode) return;
  try {
    
  class FvScrollProgress extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.hero-fv');
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      const distance = this.section ? this.section.offsetHeight : window.innerHeight;
      if (distance <= 0) return;
      const progress = Math.min(Math.max(window.scrollY / distance, 0), 1);
      this.style.setProperty('--scroll-progress', progress.toFixed(4));
    }
  }

  if (!customElements.get('fv-scroll-progress')) {
    customElements.define('fv-scroll-progress', FvScrollProgress);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel-element"]) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      // Read by structure rather than by class: the two sections that use this
      // element keep their own class names.
      this.track = this.querySelector(':scope > ul');
      this.items = Array.from(this.querySelectorAll(':scope > ul > li'));
      const nav = this.parentElement.querySelector('.carousel-nav');
      if (!this.track || !nav || this.items.length === 0) return;

      this.nav = nav;
      this.dots = Array.from(nav.querySelectorAll('.carousel-nav__dot'));
      // Mapped from the buttons so the two arrays stay index-for-index. The list
      // item is what gets hidden, not the button (see the stylesheet).
      this.dotItems = this.dots.map((dot) => dot.parentElement);
      this.prev = nav.querySelector('.carousel-nav__button--prev');
      this.next = nav.querySelector('.carousel-nav__button--next');

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.scrollToIndex(i)));

      this.ticking = false;
      this.addEventListener('scroll', () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.sync();
        });
      }, { passive: true });

      // The row can stop overflowing when the viewport grows, and the number of
      // cards that fit — so the number of dots — changes with it, so the check
      // has to run again on resize and not only once at connect.
      new ResizeObserver(() => this.sync()).observe(this);

      this.sync();
    }

    // The `scrollLeft` that puts `item` at the left edge. It is also the snap
    // position the browser lands on: `scroll-snap-align: start` measures from the
    // scrollport's start edge plus its scroll-padding, and the track's leading
    // inset is that same value.
    offsetOf(item) {
      return item.offsetLeft - this.items[0].offsetLeft;
    }

    get maxScroll() {
      return this.scrollWidth - this.clientWidth;
    }

    // 00_common D-6: one dot per position the row can be sent to, not one per
    // product. Every card start past the end of the scroll range resolves to the
    // same place, so on the comp's eight cards the 6th, 7th and 8th dots could
    // never fill and did nothing when pressed. How many cards fit — and so how
    // many positions are left — depends on the layout setting and the viewport
    // width, which is why this cannot be counted in Liquid.
    //
    // The same number decides whether the nav is worth showing at all: fewer
    // than two positions means every card is already within reach — the
    // four-cards-or-fewer case — and there is nowhere to send the row. Counting
    // positions is what keeps that honest, because the track carries a trailing
    // inset the width of the page margin and so makes `scrollWidth` exceed
    // `clientWidth` by a couple of pixels even when nothing is cut off.
    get positionCount() {
      // 1px of slack: the contained layout divides the content column by four,
      // so the card width — and every offset built from it — carries a fraction.
      const limit = this.maxScroll + 1;
      return this.items.filter((item) => this.offsetOf(item) <= limit).length;
    }

    // The card nearest the left edge.
    get index() {
      const left = this.scrollLeft;
      let best = 0;
      let bestDistance = Infinity;
      this.items.forEach((item, i) => {
        const distance = Math.abs(this.offsetOf(item) - left);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    }

    // Which position the row is at, and therefore which dot is filled. Clamped
    // because mid-scroll — and in a browser that lets a mandatory-snap row rest
    // between snap positions — the nearest card start can be one the scroll
    // range can no longer reach, which would put the fill on a hidden dot.
    get position() {
      return Math.min(this.index, this.positionCount - 1);
    }

    step(direction) {
      this.scrollToIndex(this.position + direction);
    }

    scrollToIndex(index) {
      // Clamped to the last reachable position so the arrows and the dots
      // address the same set of places; past it every index lands at the end of
      // the range anyway.
      const target = this.items[Math.min(Math.max(index, 0), this.positionCount - 1)];
      if (!target) return;
      this.scrollTo({
        left: this.offsetOf(target),
        behavior: 'smooth'
      });
    }

    sync() {
      // Measured before anything is written: hiding a dot or the nav dirties
      // layout, and reading back in the same frame would force a second pass.
      //
      // Whether this element is a scrollport at all is read from the cascade
      // rather than inferred from its geometry. Below the breakpoint the track is
      // a two-column grid with scrolling turned off, where card starts repeat per
      // row: `positionCount` would report three positions on the comp's four
      // cards, and `maxScroll` cannot stand in for it either — the track's
      // trailing inset makes `scrollWidth` exceed `clientWidth` by a page margin
      // even when nothing is cut off.
      const scrolls = getComputedStyle(this).overflowX !== 'visible';
      const count = scrolls ? this.positionCount : 0;
      const current = count > 0 ? this.position : 0;

      // The controls are live from here on, so they can be shown and reached.
      this.nav.classList.remove('carousel-nav--idle');

      // A row that cannot be sent anywhere should not be a tab stop either. The
      // attribute is in the markup so the row is keyboard-scrollable before this
      // script runs, and this is the case where that stops being true: the grid
      // below the breakpoint, and the four-cards-or-fewer row above it.
      if (count < 2) {
        this.removeAttribute('tabindex');
        this.nav.hidden = true;
        return;
      }

      this.setAttribute('tabindex', '0');
      this.nav.hidden = false;

      this.dots.forEach((dot, i) => {
        this.dotItems[i].hidden = i >= count;
        dot.classList.toggle('is-active', i === current);
        // The fill is the only thing that says which dot is current, and colour
        // alone does not carry to assistive technology (WCAG 1.4.1).
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      // Asked of the position rather than of `scrollLeft`, because the end of
      // the range sits a few pixels past the last snap position (the track's
      // trailing inset) and a snapped row therefore never reports being there.
      // Otherwise the last dot fills while the arrow still invites a press that
      // cannot move anything.
      this.prev.disabled = current === 0;
      this.next.disabled = current === count - 1;
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // One stage, many frames, and two ways of showing one of them. Which one is live
  // is a layout decision, so it is read from the cascade rather than decided here:
  // `--stage-scrolls: 0` (the 1440 comp) leaves one frame in the flow and swaps it
  // when a thumbnail is clicked; `1` (the SP comp, 396:35368) lays the frames out
  // as a snapping row that swipe, the arrows and the thumbnails all drive. Putting
  // the breakpoint in the stylesheet and reading the flag keeps one copy of it —
  // a `matchMedia('(max-width: 1023px)')` in here would be a second copy that
  // nothing keeps in step.
  //
  // The markup and CSS live in `snippets/product-gallery.liquid`; only this class
  // had to move out of it. A snippet's javascript tag never reaches
  // `compiled_assets/scripts.js` — the published theme carried this snippet's CSS
  // and every section's class but not `ProductGallery`, so the thumbnails did
  // nothing in production. See `liquid-gotchas.md`.
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.product-gallery__stage');
      this.frames = Array.from(this.querySelectorAll('[data-gallery-frame]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      if (!this.stage || this.frames.length === 0) return;

      this.nav = this.querySelector('.carousel-nav');
      this.counter = this.querySelector('[data-carousel-counter]');
      // Only the next arrow is held: the two are told apart by identity in the
      // click handler, and neither is disabled any more (04_product S-1).
      this.next = this.querySelector('.carousel-nav__button--next');
      this.index = 0;
      this.mode = null;

      // Delegated from the element root so it survives a section re-render.
      this.addEventListener('click', this.onClick);
      this.stage.addEventListener('scroll', this.onScroll, { passive: true });

      // The arrows cannot do anything until this class has the stage, so they stay
      // out of the tab order and out of the accessibility tree until now — the row
      // itself still swipes without them. See `snippets/carousel-nav.liquid`.
      if (this.nav) this.nav.classList.remove('carousel-nav--idle');

      // Both the mechanism and the slide pitch change with the viewport, so this
      // has to run again on resize and not only once at connect.
      new ResizeObserver(() => this.sync()).observe(this);
      this.sync();
    }

    get scrolls() {
      return getComputedStyle(this.stage).getPropertyValue('--stage-scrolls').trim() === '1';
    }

    // The `scrollLeft` that puts frame `index` at the scrollport's start edge,
    // which is also the position `scroll-snap-align: start` rests on.
    offsetOf(index) {
      return this.frames[index].offsetLeft - this.frames[0].offsetLeft;
    }

    onClick = (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        this.goTo(Number(thumb.dataset.galleryThumb));
        return;
      }

      const button = event.target.closest('.carousel-nav__button');
      if (!button) return;
      this.goTo(this.index + (button === this.next ? 1 : -1));
    };

    // A swipe fires this many times on the way to one frame, so the frame is read
    // once per animation frame and only a change is written back.
    onScroll = () => {
      if (this.ticking || !this.scrolls) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;

        let nearest = 0;
        let best = Infinity;
        this.frames.forEach((frame, i) => {
          const distance = Math.abs(this.offsetOf(i) - this.stage.scrollLeft);
          if (distance < best) {
            best = distance;
            nearest = i;
          }
        });

        if (nearest === this.index) return;
        this.index = nearest;
        this.paint();
      });
    };

    goTo(index) {
      // 04_product S-1 answered "wrap": past the last frame is the first one and
      // before the first is the last, so both arrows always move the row. The
      // thumbnails pass an index that is already in range, so only the arrows
      // ever reach the wrap.
      const count = this.frames.length;
      const wrapped = index < 0 || index >= count;
      this.index = ((index % count) + count) % count;
      this.paint();
      if (this.scrolls) {
        // A wrap crosses the whole row. Animating it would run every frame past
        // the viewport on the way there, which reads as a much longer press than
        // the one the finger made — so the wrap jumps and the ordinary step
        // keeps its animation.
        this.stage.scrollTo({
          left: this.offsetOf(this.index),
          behavior: wrapped ? 'instant' : 'smooth',
        });
      }
    }

    // The strip shows five of the comp's thumbnails and scrolls for the rest, so
    // sending the stage past the fifth one would leave the strip behind. Only the
    // strip's own `scrollLeft` is touched — `scrollIntoView` would take the page
    // with it when the gallery is not the thing on screen.
    revealThumb() {
      const strip = this.thumbs[0] && this.thumbs[0].parentElement;
      const thumb = this.thumbs[this.index];
      if (!strip || !thumb) return;

      const start = thumb.offsetLeft - this.thumbs[0].offsetLeft;
      const end = start + thumb.offsetWidth;
      if (start < strip.scrollLeft) {
        strip.scrollTo({ left: start, behavior: 'smooth' });
      } else if (end > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: end - strip.clientWidth, behavior: 'smooth' });
      }
    }

    sync() {
      const scrolls = this.scrolls;
      const switched = scrolls !== this.mode;
      this.mode = scrolls;

      // Painting first: in the swapping mode the frames past the current one are
      // out of the flow, so their offsets only exist once the row's rules apply.
      if (switched) this.paint();

      // A resize changes the slide pitch, which leaves the row resting between two
      // frames; a mode change has no scroll position to inherit at all.
      if (scrolls) this.stage.scrollLeft = this.offsetOf(this.index);
    }

    paint() {
      // In the swiping mode every frame is in the flow — the scrollport is what
      // shows one at a time — and in the swapping mode only the current one is.
      const scrolls = this.mode;
      this.frames.forEach((frame, i) => {
        frame.hidden = scrolls ? false : i !== this.index;
      });

      this.thumbs.forEach((thumb, i) => {
        if (i === this.index) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      this.revealThumb();

      if (this.counter) {
        this.counter.textContent = this.counter.dataset.counterTemplate.replace(
          '[index]',
          String(this.index + 1)
        );
      }

      // The arrows used to dim at the ends, which is what the row could honestly
      // say while it stopped there. 04_product S-1 answered the comp's own
      // full-strength arrows with "make them wrap" instead, so there is no end
      // to report and neither arrow is ever disabled.
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  // The comp draws the stepper but not what it does. Clamping at the field's own
  // `min` keeps the two paths (typing, stepping) agreeing, and dispatching
  // `change` lets anything else listening on the field react.
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.quantity__input');
      this.addEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const step = event.target.closest('[data-quantity-step]');
      if (!step || !this.input) return;

      const min = Number(this.input.min) || 1;
      const next = (Number(this.input.value) || min) + Number(step.dataset.quantityStep);
      this.input.value = String(Math.max(min, next));
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    };
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  // 04_product A-5. The radios own the selection; this only translates it into
  // the things the option values cannot express by themselves — the variant id
  // the form has to post, the price, whether the variant can be bought, and
  // which of the *other* buttons are still reachable from the new selection.
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const map = this.querySelector('[data-variant-map]');
      this.variants = map ? JSON.parse(map.textContent) : [];
      this.idInput = this.querySelector('[data-variant-id]');
      this.inputs = Array.from(this.querySelectorAll('.product-info__option-input'));
      this.form = this.closest('form');

      // The markup ships this input disabled so that with scripting off the
      // `<noscript>` select is the only control named `id`. Nothing else posts
      // the variant, so enabling it has to come before anything can be bought.
      if (this.idInput) this.idInput.disabled = false;

      this.addEventListener('change', this.onChange);
    }

    onChange = () => {
      const chosen = this.inputs.filter((input) => input.checked).map((input) => input.value);
      this.apply(this.match(chosen));
      this.remark(chosen);
    };

    // A combination identifies a variant only when every position agrees, so the
    // comparison is positional rather than a set membership test.
    match(combination, availableOnly = false) {
      return this.variants.find(
        (variant) =>
          (!availableOnly || variant.available) &&
          variant.options.length === combination.length &&
          variant.options.every((value, index) => value === combination[index])
      );
    }

    apply(variant) {
      const scope = this.form ?? document;
      const available = Boolean(variant && variant.available);
      const submit = scope.querySelector('.product-info__submit');
      const label = scope.querySelector('.product-info__submit-label');
      const quantity = scope.querySelector('.quantity');
      const amount = document.querySelector('.product-info__price .price__amount');

      if (variant && this.idInput) this.idInput.value = String(variant.id);
      if (variant && amount) amount.textContent = variant.price;
      if (submit) submit.disabled = !available;
      if (label) {
        label.textContent = available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
      }
      // 04_product A-4: hidden rather than disabled, so the button moves up into
      // the space instead of leaving a dead row behind.
      if (quantity) quantity.hidden = !available;

      // Only back-ordered variants have a note at all, so an unmatched
      // combination or a variant with stock leaves every note hidden.
      scope.querySelectorAll('[data-backorder-variant]').forEach((note) => {
        note.hidden = !variant || note.dataset.backorderVariant !== String(variant.id);
      });

      // `replaceState` rather than a navigation: the page is already showing the
      // variant, and this only makes the URL shareable. A push would put a
      // history entry between the visitor and the page they arrived from.
      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
      }
    }

    remark(chosen) {
      this.inputs.forEach((input) => {
        const combination = chosen.slice();
        combination[Number(input.dataset.optionPosition) - 1] = input.value;

        const reachable = Boolean(this.match(combination, true));
        const label = input.nextElementSibling;
        if (!label) return;

        label.classList.toggle('product-info__option-value--unavailable', !reachable);
        const note = label.querySelector('[data-option-unavailable]');
        if (note) note.hidden = reachable;
      });
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // The results are products, so the query has to say so. Every link the theme
  // builds already does; a URL typed or shared by hand may not, and Shopify then
  // counts the articles and pages it matched in the total this page prints while
  // the grid shows none of them. Rewriting it once on arrival keeps the sentence
  // and the grid describing the same set. `replace` rather than `assign` so the
  // un-normalised URL does not sit in the back button, and the condition is
  // false after the rewrite, so it runs once.
  (() => {
    const params = new URLSearchParams(window.location.search);
    if (!params.get('q') || params.get('type') === 'product') return;

    params.set('type', 'product');
    window.location.replace(`${window.location.pathname}?${params}`);
  })();

  // The same upgrade `sections/collection.liquid` applies to the sort control:
  // "pick, then press 適用" becomes "pick and go". It is repeated rather than
  // shared because a snippet's javascript block is not delivered (see the note
  // at the foot of `snippets/collection-toolbar.liquid`), and the
  // `customElements.get` guard makes defining it twice a no-op on any page that
  // somehow loads both.
  class SortSelect extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select');
      if (!select || !select.form) return;

      select.addEventListener('change', () => {
        if (typeof select.form.requestSubmit === 'function') {
          select.form.requestSubmit();
        } else {
          select.form.submit();
        }
      });
    }
  }

  if (!customElements.get('sort-select')) {
    customElements.define('sort-select', SortSelect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-rows"] && !Shopify.designMode) return;
  try {
    
  // 02_about A-2 のフェードイン。行を透明にする属性はここで初めて付く。CSS 側は
  // その属性に紐づいているだけなので、この bundle が落ちても（JS 無効・読み込み
  // 失敗・古いブラウザ）行は最終状態のまま見えている。
  class StoryRowsReveal extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;

      const rows = this.querySelectorAll('.story-rows__row');
      if (!rows.length) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            // 一度出たら戻さない。監視も外して、以降のスクロールで再発火させない。
            entry.target.dataset.reveal = 'revealed';
            this.observer.unobserve(entry.target);
          }
        },
        // 行の高さは入稿写真の縦横比で決まり、狭い画面では画面より高くなる。
        // 割合の閾値だとその行が発火しないので、下端から 80px 入った時点で撃つ。
        { rootMargin: '0px 0px -80px 0px' }
      );

      for (const row of rows) {
        // すでに画面内にある行を透明にすると、bundle が走った瞬間に見えていた
        // ものが消えて再表示される。読み込み時点で見えている行は最終状態に
        // 据え置き、まだ下にある行だけを監視する。
        if (row.getBoundingClientRect().top < window.innerHeight) continue;
        row.dataset.reveal = 'armed';
        this.observer.observe(row);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('story-rows-reveal')) {
    customElements.define('story-rows-reveal', StoryRowsReveal);
  }

  } catch(e) { console.error(e); }
})();
})();
